/**
 *  文本显示组件
 */
import { Tooltip } from 'antd';
import React, { useMemo } from 'react';

const ShowText = (props) => {
  const { text, showNum = 20 } = props;

  const content = useMemo(() => {
    if (!text) {
      return '--';
    }
    const len = String(text).length;
    if (len > showNum) {
      return `${String(text).slice(0, showNum)}...`;
    }
    return String(text);
  }, [text, showNum]);

  return (
    <Tooltip title={text || '--'}>
      <span>{content}</span>
    </Tooltip>
  );
};

export default ShowText;
